module.exports = __webpack_public_path__ + "static/media/logo.55afbab8.png";